<div class="membership-container">
    <div class="membership-content">
        <div><p><i class="fa-solid fa-cross"></i> የክርስትና ጥምቀት <br> (Baptism)</p></div>
        <p><i class="fa-solid fa-cross"></i> ጋብቻ <br> (Wedding)</p>
        <p><i class="fa-solid fa-cross"></i> ጸሎተ ፍህታት (Prayer of repentance)</p>
        <p><i class="fa-solid fa-cross"></i> መንፈሳዊ የምስክር ወረቀቶች <br>(Spirtual counseling)</p> 
        <p><i class="fa-solid fa-cross"></i> የአባልነት ማስረጃና ወረቀት <br> (Membership certification)</p>
        <p><i class="fa-solid fa-cross"></i> እርስ በእርስ መረዳዳት፣ የታመመ መጠየቅ <br> (Community support) </p>
        <p><i class="fa-solid fa-cross"></i> በቤተ ክርስቲያኑ አስተዳደር ውስጥ መምረጥ እና መመረጥ መቻል <br> (Have the privilge to serve as church leadership member)</p>
        <p><i class="fa-solid fa-cross"></i> የካህናት ምክር፣ ጸሎት፣ ትምህርተ፣ እና ንስሀ መቀበል <br>(Repentance and teaching adminstered by the clergies)</p>
        <p><i class="fa-solid fa-cross"></i> የሕሙማን ፣ የቄዴር ፣ እና የንስሐ ጥምቀት <br>(Services of repentance)</p>
    </div>
    <div class="divider"></div>
    <div class="form-link">
        <div class="img-container">
            <img src="./assets/two.jpg"/>
        </div>
        <div class="form-container">
            <p>ደብረ ብስራት ቅዱስ ገብርኤል ገዳም አባል ለመሆን፣ ከዚህ በታች ያለውን ፎርም ይሙሉ </p>
           <div class="link"> <a href="https://forms.gle/Q2nhpibwL9YLck167"> BE A MEMBER</a></div>
        </div> 
    </div>
</div>





